import React, { useContext, useState, useEffect } from "react";
import GetIntro from "../../actions/intros/GetIntro";
import GetWalkthroughs from "../../actions/GetWalkthroughs";
import IntroModal from "./IntroModal";
import Localbase from "localbase";
import DetectDevice from "../../data/DetectDevice";
import { AuthContext } from "../../context/AuthContext";

const GettingStartedDashboard = () => {
  const { user } = useContext(AuthContext);
  const [beginner, setBeginner] = useState(true);
  const db = new Localbase();
  const device = DetectDevice();
  const [videos, setVideos] = useState(null);
  const [suggestions, setSuggestions] = useState(null);
  const [limit, setLimit] = useState(device === "mobile" ? 3 : 2);
  const [totalVideos, setTotalVideos] = useState(0);
  const [loading, setLoading] = useState(false);
  const [noMore, setNoMore] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    NewVideos();
  }, []);

  const NewVideos = async () => {
    setLoading(true);

    const res = await GetWalkthroughs({
      payload: {
        limit: limit,
        SessionId: user ? user.SessionId : null,
      },
    });

    if (res) {
      setLoading(false);
    }

    if (res && res.status === "success") {
      setVideos(res.videos);

      if (res.videos) {
        if (res.videos.length === res.total_videos) {
          setNoMore(true);
        }
        setTotalVideos(res.videos.length);
      }

      setSuggestions(res.suggestions);

      db.collection("paths").add(
        {
          videos: res.videos,
        },
        "walkthroughs",
      );
    }
  };

  useEffect(() => {
    db.collection("paths")
      .doc("walkthroughs")
      .get()
      .then((data) => {
        if (data && data.videos) {
          setVideos(data.videos);
        }
      });

    const CheckVisitor = async () => {
      const res = await GetIntro({
        payload: {
          user: user ? user.SessionId : null,
          name: "walkthrough-video",
        },
      });

      if (res && res.status === "success") {
        setBeginner(res.beginner);
      }
    };

    CheckVisitor();
  }, [user]);

  const [video, setVideo] = useState(null);
  const [visibility, setVisibility] = useState(false);
  const [poster, setPoster] = useState(null);

  const HandleClose = () => setVisibility(false);

  const PlayVideo = ({ item }) => {
    setVideo(item.url);
    setPoster(item.cover_image);
    setVisibility(true);
  };

  return (
    <div>
      <IntroModal
        visibility={visibility}
        nosound={true}
        poster={poster}
        video={video}
        HandleClose={HandleClose}
      />

      {/* Internal responsive CSS */}
      <style>{`
        @media (max-width: 768px) {
          .gs-card {
            flex-direction: column !important;
            padding: 12px !important;
          }
          .gs-thumb {
            width: 100% !important;
            min-width: 100% !important;
          }
          .gs-thumb img {
            height: 180px !important;
          }
          .gs-btn {
            width: 100% !important;
            text-align: center;
          }
          .gs-title {
            font-size: 1rem !important;
          }
        }
      `}</style>

      <div
        className="rounded-4 overflow-hidden shadow-lg border-0"
        style={{
          background: "#ffffff",
          boxShadow:
            "0 10px 30px rgba(15, 23, 42, 0.08), 0 4px 12px rgba(255, 98, 0, 0.06)",
        }}
      >
        {/* Header */}
        <div
          className="p-3 p-md-4"
          style={{
            background: "linear-gradient(90deg, #0f172a 0%, #1e293b 100%)",
            color: "#ffffff",
          }}
        >
          <h4
            className="mb-0 fw-semibold"
            style={{
              letterSpacing: "-0.4px",
              position: "relative",
              paddingLeft: "18px",
              fontSize: device === "mobile" ? "1.1rem" : "1.25rem",
            }}
          >
            <span
              style={{
                position: "absolute",
                left: 0,
                top: "50%",
                transform: "translateY(-50%)",
                width: "6px",
                height: "28px",
                background: "#FF6200",
                borderRadius: "3px",
              }}
            />
            Get Started with Skills Uprise!
          </h4>
        </div>

        {/* Content */}
        <div className="p-3 p-md-4 pt-3">
          {loading ? (
            <div className="text-center py-5">
              <div
                style={{
                  width: "48px",
                  height: "48px",
                  border: "5px solid #e2e8f0",
                  borderTop: "5px solid #FF6200",
                  borderRadius: "50%",
                  animation: "spin 1s linear infinite",
                  margin: "0 auto",
                }}
              />
              <style>{`
                @keyframes spin {
                  0% { transform: rotate(0deg); }
                  100% { transform: rotate(360deg); }
                }
              `}</style>
              <p className="mt-3 text-muted">Loading tutorials...</p>
            </div>
          ) : videos && videos.length > 0 ? (
            <div className="d-flex flex-column gap-3 gap-md-4">
              {videos.map((item, index) => (
                <div
                  key={index}
                  onClick={() => PlayVideo({ item })}
                  className="d-flex gs-card gap-3 p-3 rounded-3"
                  style={{
                    background: "#ffffff",
                    border: "1px solid #e2e8f0",
                    cursor: "pointer",
                    boxShadow: "0 4px 12px rgba(0,0,0,0.04)",
                    transition: "0.3s ease",
                  }}
                >
                  <div
                    className="gs-thumb"
                    style={{
                      flex: "0 0 220px",
                      minWidth: "220px",
                    }}
                  >
                    <img
                      src={item.cover_image}
                      alt={item.title}
                      className="w-100 rounded-3"
                      style={{
                        height: "140px",
                        objectFit: "cover",
                        border: "1px solid #e2e8f0",
                      }}
                    />
                  </div>

                  <div className="flex-grow-1 d-flex flex-column justify-content-between">
                    <h6
                      className="mb-3 gs-title"
                      style={{
                        fontSize: "1.1rem",
                        fontWeight: 600,
                        color: "#0f172a",
                      }}
                    >
                      {item.title}
                    </h6>

                    <button
                      className="gs-btn px-4 py-2 rounded-pill fw-semibold"
                      style={{
                        color: "#FF6200",
                        border: "2px solid #FF6200",
                        background: "transparent",

                        fontSize: device === "mobile" ? "0.9rem" : "0.9rem",
                        minWidth: device === "mobile" ? "140px" : "60px",
                      }}
                    >
                      Watch Tutorial →
                    </button>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="text-center py-5 text-muted">
              <h5>No getting started videos available yet</h5>
              <p>
                We're preparing helpful tutorials for you — check back soon!
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GettingStartedDashboard;